<div id="content" class="allcp-form" ng-controller="CustomerAccountController" ng-init="init()">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <header class="navbar navbar-fixed-top subnavbar bg-system">
        <ul class="nav navbar-nav nav-tabs navbar-left">
            <li class="active">
                <a target="_self" class="btn btn-operation ml10" href="#change-password" data-toggle="tab">Change Password</a>
            </li>
        </ul>
    </header>
    <div class="panel-body">
        <div class="row">
            <div class="col-md-12">
                <div class="tab-content">
                    <div class="tab-pane active" id="change-password">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6">
                                    <form class="form-horizontal" name="change_password_form" ng-submit="updatePassword()">
                                        <div class="form-group floating show-hide-pass">
                                            <input type="{{inputTypeArr[0]}}" name="old_password" id="old_password" ng-minlength="6" placeholder="******" class="form-control " ng-model="password.old_password" required>
                                            <label>Old Password</label>
                                            <a href="" ng-click="hideShowPasswordArr(0)">
                                                <i ng-if="inputTypeArr[0] == 'password'" class="fa fa-eye-slash"></i>
                                                <i ng-if="inputTypeArr[0] == 'text'" class="fa fa-eye"></i>
                                            </a>
                                            <span ng-show="change_password_form.old_password.$dirty&&change_password_form.old_password.$error.required">Required *</span>
                                            <span ng-show="change_password_form.old_password.$dirty&&change_password_form.old_password.$error.minlength">Value should be more than 6</span>
                                        </div>
                                        <div class="form-group floating show-hide-pass">
                                            <input type="{{inputTypeArr[1]}}" name="new_password" id="new_password" ng-minlength="6" placeholder="******" class="form-control " ng-model="password.new_password" required>
                                            <label>
                                                New Password
                                            </label>
                                            <a href="" ng-click="hideShowPasswordArr(1)">
                                                <i ng-if="inputTypeArr[1] == 'password'" class="fa fa-eye-slash"></i>
                                                <i ng-if="inputTypeArr[1] == 'text'" class="fa fa-eye"></i>
                                            </a>
                                            <span ng-show="change_password_form.new_password.$dirty&&change_password_form.new_password.$error.required">Required *</span>
                                            <span ng-show="change_password_form.new_password.$dirty&&change_password_form.new_password.$error.minlength">Value should be more than 6</span>
                                        </div>
                                        <div class="form-group floating show-hide-pass">
                                            <input type="{{inputTypeArr[2]}}" name="cofirm_new_password" id="cofirm_new_password" placeholder="******" class="form-control " ng-model="password.new_password_repeat" required compare-to="password.new_password">
                                            <label>
                                                Repeat New Password
                                            </label>
                                            <a href="" ng-click="hideShowPasswordArr(2)">
                                                <i ng-if="inputTypeArr[2] == 'password'" class="fa fa-eye-slash"></i>
                                                <i ng-if="inputTypeArr[2] == 'text'" class="fa fa-eye"></i>
                                            </a>
                                            <span ng-show="change_password_form.cofirm_new_password.$dirty&&change_password_form.cofirm_new_password.$error.required">Required *</span>
                                            <span ng-show="change_password_form.cofirm_new_password.$error.compareTo">Value should be same !</span>
                                        </div>
                                        <button type="submit" class="btn ">Update</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
